/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Landing_Meta_TitleInputs */

const es_landing_meta_title = /** @type {(inputs: Landing_Meta_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Zarpar — Alquiler de barcos entre particulares`)
};

const gl_landing_meta_title = /** @type {(inputs: Landing_Meta_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Zarpar — Alugueiro de barcos entre particulares`)
};

const en_landing_meta_title = /** @type {(inputs: Landing_Meta_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Zarpar — Peer-to-peer boat rentals`)
};

/**
* | output |
* | --- |
* | "Zarpar — Peer-to-peer boat rentals" |
*
* @param {Landing_Meta_TitleInputs} inputs
* @param {{ locale?: "es" | "gl" | "en" }} options
* @returns {LocalizedString}
*/
export const landing_meta_title = /** @type {((inputs?: Landing_Meta_TitleInputs, options?: { locale?: "es" | "gl" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Landing_Meta_TitleInputs, { locale?: "es" | "gl" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "gl") return gl_landing_meta_title(inputs)
	if (locale === "en") return en_landing_meta_title(inputs)
	return es_landing_meta_title(inputs)
});